import React from "react";
import VacancyCard from "./VacancyCard";
import { useLanguage } from "../config/LanguageContext";
import GSDVacancy from "./GSDVacancy";
import TestVacancy from "./TestVacancy";

function Vacancies() {
  const { currentLanguage, translations } = useLanguage();

  return (
    <div className="vacancies-container">
      <div className="vacancies-wrapper">
        <h1 className="secondary">
          {
            {
              en: "Current Vacancies",
              fr: "Postes à pourvoir",
              de: "Aktuelle Stellenangebote",
              es: "Vacantes actuales",
            }[currentLanguage]
          }
        </h1>
        <div className="vacancies-card-section-container">
          {/* <div className="vacancies-card-section-wrapper">
            <GSDVacancy />
            <TestVacancy /> 
          </div> */}
          <p className="no-openings-container">
            {
              {
                en: "No vacancies available at the moment.",
                fr: "Aucun poste à pourvoir pour le moment.",
                de: "Derzeit sind keine Stellenangebote verfügbar.",
                es: "No hay vacantes disponibles en este momento.",
              }[currentLanguage]
            }
          </p>
        </div>
      </div>
    </div>
  );
}

export default Vacancies;

{
  /* <VacancyCard openingKey="opening3" /> TEMPLATE DONT DELETE */
}
